import { render, staticRenderFns } from "./ProjeTanimla.vue?vue&type=template&id=365a1db2&scoped=true&"
import script from "./ProjeTanimla.vue?vue&type=script&lang=js&"
export * from "./ProjeTanimla.vue?vue&type=script&lang=js&"
import style0 from "./ProjeTanimla.vue?vue&type=style&index=0&id=365a1db2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365a1db2",
  null
  
)

export default component.exports